import axios from 'axios';
import { SERVER_STATUS_API_URL } from 'src/constants/mindtime/constants';
import type {
  ServerGroupCardData,
  ServerInfo,
  ServerStatusApiItem,
  ServerStatusApiResponse,
} from 'src/types/mindtime/support';
import axiosInstance from 'src/utils/axios';
import parse from 'src/utils/parse';
import logger from 'src/utils/logger';

const REGION_CONFIG: Record<'nl' | 'de', Pick<ServerGroupCardData, 'label' | 'flag'>> = {
  nl: {
    label: 'Dutch servers status',
    flag: '/static/icons/netherlands-flag.svg',
  },
  de: {
    label: 'German servers status',
    flag: '/static/icons/de_flag.svg',
  },
};

const mapServerItem = (item: ServerStatusApiItem): ServerInfo => ({
  name: item.id,
  type: 'CBS',
  status: item.online ? 'Online' : 'Offline',
});

const mapRegionToGroup = (
  region: 'nl' | 'de',
  servers: ServerStatusApiItem[]
): ServerGroupCardData => {
  const online = servers.filter((server) => server.online).length;

  return {
    ...REGION_CONFIG[region],
    total: servers.length,
    online,
    servers: servers.map(mapServerItem),
    defaultExpanded: online < servers.length,
  };
};

export const mapServerStatusToGroups = (
  response: ServerStatusApiResponse
): ServerGroupCardData[] => [
  mapRegionToGroup('nl', response.data.nl ?? []),
  mapRegionToGroup('de', response.data.de ?? []),
];

class MindtimeSupportApi {
  async getServiceStatus(): Promise<any> {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(`${process.env.REACT_APP_BSI}/mindtime/support/service-status`)
        .then((response) => {
          response = parse(response);
          resolve(response?.data);
        })
        .catch((error) => {
          logger(error, 'error');
          reject(error);
        });
    });
  }

  async getServerStatus(): Promise<ServerGroupCardData[]> {
    const response = await axios.get<ServerStatusApiResponse>(SERVER_STATUS_API_URL);
    return mapServerStatusToGroups(response.data);
  }

  async submitTicket(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      axiosInstance
        .post(`${process.env.REACT_APP_BSI}/mindtime/support/tickets`, payload)
        .then((response) => {
          response = parse(response);
          resolve(response?.data);
        })
        .catch((error) => {
          logger(error, 'error');
          reject(error);
        });
    });
  }
}

export const mindtimeSupportApi = new MindtimeSupportApi();
